import { Tag, Tooltip } from '@nackle/paper';
import React, { Component } from 'react';
import { formatCmxCabinetNameKey } from 'routes/updatecmx/cmxKeyNames';
import { TranslationControllerWrapper } from 'routes/updatecmx/TranslationControllerWrapper';
import { AugmentedRoom } from './dux';

interface Props {
    item: AugmentedRoom;
}

export class RoomLabel extends Component<Props> {
    public render() {
        const room = this.props.item;
        const cabinetCount = room.cabinets.length;

        const tooltipContent = <>{
            room.cabinets.map((entry) =>
                <div key={entry.cabinetId}>
                    {entry.cabinet && entry.cabinet.name}

                    <TranslationControllerWrapper
                        keyName={formatCmxCabinetNameKey(entry.cabinetId)}
                    >
                        {(props) => props.isLoaded && (
                            props.defaultCustomTranslation && `(${props.defaultCustomTranslation})` ||
                            props.defaultGoldTranslation && `(${props.defaultGoldTranslation})`
                        )}
                    </TranslationControllerWrapper>
                </div>
            )
        }</>;

        return <>
            {room.freePlay && <Tag>Instant Play</Tag>}
            {' '}
            {room.name}
            {' '}
            <Tooltip
                className='tooltip-indicator'
                title={tooltipContent}
                // usePortal={false}
            >
                <span>({cabinetCount} cabinet{cabinetCount === 1 ? '' : 's'})</span>
            </Tooltip>
        </>;
    }
}
